import { render, staticRenderFns } from "./Player-style.vue?vue&type=template&id=64b22100"
import script from "./Player-style.vue?vue&type=script&lang=js"
export * from "./Player-style.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports